import React from 'react';
import { countryToCurrencyMap } from './country-to-currency';
import { CircleFlag } from 'react-circle-flags';

// Define a type for the keys of countryToCurrencyMap
type CurrencyCode = keyof typeof countryToCurrencyMap;

// Update the component to use the CurrencyCode type
const FlagComponent = ({ currencyCode, size = 'M' }: { currencyCode: CurrencyCode, size?: 'S' | 'M' | 'L' | 'XL' | 'XXL' }) => {
    const sizeMap = {
        S: 16,
        M: 24,
        L: 32,
        XL: 48,
        XXL: 64
    }
  // Retrieve the list of ISO country codes for the given currency
  const countryCode = countryToCurrencyMap[currencyCode];

  if (!countryCode) {
    return <div>Country not found for currency</div>;
  }

  return (
      <CircleFlag countryCode={countryCode.toLowerCase()} width={sizeMap[size]} height={sizeMap[size]} />
  );
};
export type { CurrencyCode };
export default FlagComponent;
